// extracted by mini-css-extract-plugin
export var highlightFade = "_23-4";
export var highlighted = "_23-3";
export var table = "_23-1";
export var tableContainer = "_23-0";
export var totalsRow = "_23-2";